import { render, staticRenderFns } from "./ui_input.vue?vue&type=template&id=2673ecdb&scoped=true&"
import script from "./ui_input.vue?vue&type=script&lang=js&"
export * from "./ui_input.vue?vue&type=script&lang=js&"
import style0 from "./ui_input.vue?vue&type=style&index=0&id=2673ecdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673ecdb",
  null
  
)

export default component.exports